import { WalletDto } from '@core/mappers/user/dtos/WalletDto';
import Balance from '@core/models/user/Balance';

export function transformWallet(dto: WalletDto): Balance {
    const balance: Balance = {
        realMoney: {
            total: dto.cash.total,
            withdrawable: dto.cash.withdrawable,
            nonWithdrawable: dto.cash.nonwithdrawable,
            reserved: dto.cash.reserved,
        },
        bonuses: {
            Sport: {
                amount: dto.bonuses.sportsbook.redeemable,
                id: null,
            },
            Freebet: {
                amount: dto.bonuses.sportsbook.non_redeemable,
                id: null,
            },
            FreeSpins: {
                amount: dto.bonuses.free_spins,
                id: null,
            },
            Bingo: {
                amount: null,
                id: null,
            },
            Casino: {
                amount: dto.bonuses.casino.redeemable + dto.bonuses.casino.non_redeemable,
                id: null,
            },
            Virtuals: {
                amount: dto.bonuses.virtuals.redeemable + dto.bonuses.virtuals.non_redeemable,
                id: null,
            },
            CasinoVirtuals: {
                amount: null,
                id: null,
            },
            Cash: {
                amount: null,
                id: null,
            },
            LiveDealer: {
                amount: null,
                id: null,
            },
            HoneyToken: {
                amount: null,
                id: null,
            },
        },
    };

    return balance;
}
